import React from "react";

const FolderContextButton = (props) => {
  return (
    <div>
      <p
        id={props.id}
        onClick={props.handler}
        className="folder-button"
      >
        {props.title}
      </p>
    </div>
  );
};

export default FolderContextButton;
